<ion-header>
  <ion-toolbar>
    <div class="header-grid">
      <div class="main-logo-sec">
        <img src="assets/images/eZintegration-black-logo.svg">
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container">
    <div class="bg-grid">
      <div class="grid-container">
        <div class="grid-content">
          <!-- <div class="company-logo-sec">
            <img src="assets/images/bizdata-header-logo.png">
          </div> -->
          <!-- <div class="main-logo-sec">
              <img src="assets/images/eZintegration-black-logo.svg">
          </div> -->
           <!-- <div class="bg-sub-content">Change Password</div>  -->
          <mat-card>
            <mat-card-content>
              <!-- <div class="views-content">
                <span class="content-1">Make sure the Password must have atleast 8 Characters, 1 Number, 1 Special Character, 1 Lowercase Character, 1 Upper Character</span>              
              </div>           -->
              <div class="form-container">
                <form [formGroup]="changePasswordform" (ngSubmit)="onChangePasswordSubmit()">
                   
                  <mat-form-field appearance="outline">
                    <mat-label>Current Password</mat-label>
                    <input [type]="currentPasswordHide ? 'password' : 'text'" formControlName="currentPassword" matInput placeholder="Old Password" required>
                    <mat-icon matSuffix (click)="currentPasswordHide = !currentPasswordHide">{{currentPasswordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>New Password</mat-label>
                    <input [type]="newPasswordHide ? 'password' : 'text'" formControlName="newPassword" matInput placeholder="New Password" required>
                    <mat-icon matSuffix (click)="newPasswordHide = !newPasswordHide">{{newPasswordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="changePasswordControls.newPassword.hasError('required') || changePasswordControls.newPassword.hasError('minlength') || changePasswordControls.newPassword.hasError('hasNumber') || changePasswordControls.newPassword.hasError('hasUpperCase') || changePasswordControls.newPassword.hasError('hasSmallCase') || changePasswordControls.newPassword.hasError('hasSpecialCharacters')">Password must have atleast 8 Characters, 1 Number, 1 Special Character, 1 Lowercase Character, 1 Upper Character.</mat-error>                  
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input [type]="confirmPasswordHide ? 'password' : 'text'" formControlName="confirmPassword" matInput placeholder="New Password" required>
                    <mat-icon matSuffix (click)="confirmPasswordHide = !confirmPasswordHide">{{confirmPasswordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="changePasswordControls.confirmPassword.hasError('NoPasswordMatch')">Password do not match. </mat-error>
                  </mat-form-field>
    
                  <div class="btn-grid">
                    <button mat-raised-button type="submit" class="btn-set-password">Change Password</button>
                  </div>
                </form>
                <!-- <div class="back-login">
                  <p>Return to <a class="signin-link" style="text-decoration: none; font-weight: 500;"  href="javascript:void(0)" (click)="login()"> Signin </a></p>
                </div> -->
              </div>
            </mat-card-content>
          </mat-card>
          <!-- <div class="pwdcahngedate">Password was last changed on 18/01/2022,02.34 PM</div> -->
          <app-powered-by-footer></app-powered-by-footer>
        </div>
      </div>
    </div>
  </div>
</ion-content>
